import React from 'react'
import PropTypes from 'prop-types'

import ListItem from './ProjectLocationsListItem'
import ProjectAddressInput from './project/ProjectAddressInput'

const ProjectLocationList = ({project_id, locations}) => {

    return (
        <div className="d-flex flex-column">
            <ProjectAddressInput project_id={project_id} />
            {
                locations.map((location, index) => <ListItem
                    key={index}
                    id={location.address_id}
                    address={location.name}
                    googleResult={location.full_address}
                    project_id={project_id}
                />)
            }
        </div>
    )

}

ProjectLocationList.propTypes = {
    project_id: PropTypes.string.isRequired,
    locations: PropTypes.array
}

export default ProjectLocationList